"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MotionResetStyles = void 0;
var _core = require("@emotion/core");
var _react = _interopRequireDefault(require("react"));
const MotionResetStyles = () => {
  const styles = (0, _core.css)`
        @media (prefers-reduced-motion: reduce) {
            *,
            *::before,
            *::after {
                animation-duration: 0.01ms !important;
                animation-iteration-count: 1 !important;
                transition-duration: 0.01ms !important;
                scroll-behavior: auto !important;
            }
        }
    `;
  return /*#__PURE__*/_react.default.createElement(_core.Global, {
    styles: styles
  });
};
exports.MotionResetStyles = MotionResetStyles;
//# sourceMappingURL=MotionResetStyles.js.map